import { render, staticRenderFns } from "./VeteranStep.vue?vue&type=template&id=58f54c31&"
import script from "./VeteranStep.vue?vue&type=script&lang=js&"
export * from "./VeteranStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports